<template>
  <div class="home">

    <Navbar title="Island Bridge Billing Systems" alt-menu title-link="/ibbs" />

    <div class="pt-0">
        <div class="relative">
            <div class="bg-black">
                <img style="opacity: .5;" draggable="false" class="object-cover w-full h-full" :src="heroImg">
            </div>

            <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%;"
                    class="align-middle text-center text-white overflow-hidden">
                <h1 class="              text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold px-4">
                    Telecom Billing for the 21<sup>st</sup> Century
                </h1>
                <h3 class="pt-12 text-gray-200 text-lg md:text-xl lg:text-2xl xl:text-3xl font-thin  px-4">
                    A new service from the team at Island Bridge Networks
                </h3>
            </div>
        </div>
    </div>

    <Footer title="Island Bridge Billing Systems" alt-menu bg-color="bg-black"/>
  </div>
</template>

<script>
import Footer   from '../components/Footer.vue'
import Navbar   from '../components/Navbar.vue'

export default {
  name: 'home',
  beforeCreate: function() {
      document.body.className = 'bg-gray-900';
  },
  components: {
      Footer, Navbar,
  },
  data () {
    return {

      heroImg: require('@/assets/sbb-dawn.jpg'),
      ibnLogo: require('@/assets/island-bridge-networks-500x500.png'),

    }
  }
}
</script>
